module.exports = __webpack_public_path__ + "media/images/blup_mirror_large-3cb734d71bccf6101c47218e4497428a.png";